import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {createDivision, updateDivision} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function DivisionForm({initialValues, onAfterSubmit}) {
  const formType = initialValues ? 'update' : 'add'

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createDivision : updateDivision
    action(values)
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }
  const formValues = initialValues || {
    division_name: '',
    division_status: '1',
  }
  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          division_name: Yup.string()
            .max(100, 'The Division name cannot exceed 100 characters')
            .required('Division Name is required')
            .notOneOf([''], 'Division Name is Required'),
          division_status: Yup.string().required('Division Status is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              required
              placeholder="Division Name"
              label="Division Name"
              name="division_name"
            />
            <FormikControl
              control="check"
              type="radio"
              options={[
                {key: 'Active', value: '1'},
                {key: 'Inactive', value: '0'},
              ]}
              required
              placeholder="Active Status"
              label="Active Status"
              name="division_status"
            />

            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default DivisionForm
